export enum SignUpPlatform {

    Profit = "PROFIT",
}
